import useApi from './useApi';
import { useEmissionReportStore } from 'context/EmissionReportContext';
import { useEffect } from 'react';
import { useToast } from 'hooks/useToast';
import { ApiEndpoints, ApiQueryParams } from './apiEndpointUtils';
import { ReportRegenerationResult } from 'types/ModelTypes';
import { isReportRegenerationDetailedResponse } from 'pages/emission/reportRegenerationUtils';

export default () => {
    const { state, getApiData } = useApi();
    const { setIsTriggeringReports } = useEmissionReportStore();
    const { toastLoader } = useToast();

    const regenerateReports = async (reportStatusIds: string) => {
        const get = getApiData({
            endpoint: ApiEndpoints.regenerateReports,
            queryParam: ApiQueryParams.regenerateReports(reportStatusIds),
            validateResponse: (data) =>
                data === true
                    ? null
                    : 'The selected report is not available for regeneration.',
            throwOnError: true,
        });
        toastLoader('Regenerating reports', 'Reports regenerated. No email was sent.', get);
        await get;
    };

    const regenerateReportsDetailed = async (reportStatusIds: string): Promise<ReportRegenerationResult[]> => {
        const requestedIds = reportStatusIds.split(',').map(Number);
        const response: unknown = await getApiData({
            endpoint: ApiEndpoints.regenerateReportsDetailed,
            queryParam: ApiQueryParams.regenerateReportsDetailed(reportStatusIds),
            validateResponse: (data) =>
                isReportRegenerationDetailedResponse(data, requestedIds) ? null : 'The report could not be checked or regenerated. Please try again.',
            throwOnError: true,
        });
        if (!isReportRegenerationDetailedResponse(response, requestedIds)) {
            throw new Error('The report could not be checked or regenerated. Please try again.');
        }
        return response.results;
    };
    const sendReportMail = async (reportStatusIds: string) => {
        const get = getApiData({
            endpoint: ApiEndpoints.sendReportMail,
            queryParam: ApiQueryParams.sendReportMail(reportStatusIds),
        });
        toastLoader('Sending reports', 'You will recieve the reports shortly', get);
        await get;
    };

    useEffect(() => {
        setIsTriggeringReports(state.isLoading);
    }, [state]);

    return { regenerateReports, regenerateReportsDetailed, sendReportMail };
};
